import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "auth-shell" }
const _hoisted_2 = { class: "auth-layout" }
const _hoisted_3 = { class: "auth-right" }
const _hoisted_4 = { class: "auth-card" }
const _hoisted_5 = {
  key: 0,
  class: "uk-form-danger auth-error",
  role: "alert",
  "aria-live": "polite"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createElementVNode("div", {
        class: "auth-left",
        "aria-hidden": "true"
      }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"auth-card-header\" data-v-b285165a><div class=\"text-center mb-6\" data-v-b285165a><h1 class=\"font-bold text-slate-900 mb-2\" style=\"font-size:2rem;line-height:1;\" data-v-b285165a>EzModal</h1></div><div class=\"auth-card-eyebrow\" data-v-b285165a>Welcome back</div><h2 class=\"auth-card-title\" data-v-b285165a>Sign in</h2></div>", 1)),
          _createElementVNode("form", {
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"])),
            class: "auth-form",
            novalidate: ""
          }, [
            _cache[3] || (_cache[3] = _createElementVNode("label", {
              class: "auth-label",
              for: "email"
            }, "E-Mail Address", -1)),
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                id: "email",
                class: _normalizeClass(["uk-input auth-input", { 'uk-form-danger': _ctx.formError }]),
                type: "email",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                required: "",
                autofocus: "",
                autocomplete: "email",
                inputmode: "email"
              }, null, 2), [
                [_vModelText, _ctx.email]
              ])
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("label", {
              class: "auth-label",
              for: "password"
            }, "Password", -1)),
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                id: "password",
                class: "uk-input auth-input",
                type: "password",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                required: "",
                autocomplete: "current-password"
              }, null, 512), [
                [_vModelText, _ctx.password]
              ])
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("button", {
              type: "submit",
              class: "uk-button uk-button-primary auth-submit"
            }, "Login", -1)),
            (_ctx.formError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.formError), 1)
                ]))
              : _createCommentVNode("", true)
          ], 32),
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "mt-6 text-center text-sm text-slate-600" }, [
            _createTextVNode(" Don't have an account? "),
            _createElementVNode("a", {
              href: "/register",
              class: "text-sky-500 hover:text-sky-600 font-semibold transition-colors duration-150"
            }, "Sign up")
          ], -1))
        ])
      ])
    ])
  ]))
}